import { STUDY_USER_TYPE } from 'components/common/Study/StudyTeamMemberForm';

/**
 * Translate a user to a study team member
 * @param {Array<{id:String, sub:String, displayName:String}>} users 
 * @param {String} institutionId 
 * @param {String} studyId 
 */
export function formatStudyTeamMembers(users, institutionId, studyId) {
    return users.map(user => {
        const team = {
            nameOfResearcher: user.nameOfResearcher,
            studyRoleId: user.studyRoleId,
            isClinicalStaff: false,
            userId: user.userId,
            institutionId,
            studyId,
            studyUserType: STUDY_USER_TYPE.TEAM,
            sub: user.sub,
        };
        if (user.id) {
            team['id'] = user.id;
        }
        return team;
    });
}
